import React, { useContext, useEffect, useState } from "react";
import { AppBar, Toolbar, Typography } from "@mui/material";
import backgroundImage from "../../images/cover.png";
import neopharm from "../../Logo/Logo_Neopharm-Eng.gif";
import LogOut from "../LogOut";
import { RolesContext } from "../../context/User";
import Tooltip from "@mui/material/Tooltip";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { MainContext } from "../../context/OpenInvoice";
import FormControl from "@mui/material/FormControl";
import { useErrValidate } from "../../utilitis/AuthorizationPage";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";

const toolbarStyle = {
  appBar: {
    zIndex: 1300,
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "200px",
  },
  title: {
    flexGrow: 1,
  },
};

const CustomToolbar = ({ style }) => {
  const [state, dispatch] = useContext(MainContext);
  const navigate = useNavigate();
  const [stateroles, dispatchroles] = useContext(RolesContext);
  const [custNum, setCustNum] = useState(
    stateroles.userId ? stateroles.userId : "",
  );
  const { validationPage } = useErrValidate();

  const getCurrentTimeMessage = () => {
    const currentHour = new Date().getHours();
    if (currentHour >= 0 && currentHour < 12) {
      return `בוקר טוב, ${stateroles.name || ""}`;
    } else if (currentHour >= 12 && currentHour < 17) {
      return `צהריים טובים, ${stateroles.name || ""}`;
    } else {
      return `ערב טוב, ${stateroles.name || ""}`;
    }
  };

  const handleChange = (event) => {
    setCustNum(event.target.value);
    handleSubmit(event.target.value);
  };

  const handleSubmit = async (custnumber) => {
    let response;
    try {
      response = await axios.get(
        `/adminPermissions/change_cust_id/${custnumber}`,
        {
          withCredentials: true,
        },
      );
    } catch (error) {
      if (error.response.status == 403) {
        navigate("/");
      }
    }
    dispatchroles({
      type: "USER_UPDATE",
      payload: {
        value: custNum,
        title: "userId",
      },
    });

    // Hospital patients: the selected customer may belong to a different hospital,
    // so the active site (used to scope hospital data like chemo records) must
    // switch too, not just the customer id.
    if (response?.data?.siteLabel) {
      dispatchroles({
        type: "USER_UPDATE",
        payload: {
          value: response.data.siteLabel,
          title: "siteLabel",
        },
      });
    }
    if (response?.data?.custdes) {
      dispatchroles({
        type: "USER_UPDATE",
        payload: {
          value: response.data.custdes,
          title: "userCustDes",
        },
      });
    }

    dispatch({
      type: "DATA_RESPONSE",
      payload: { value: [] },
    });
  };

  return (
    <AppBar position="static" style={{ ...toolbarStyle.appBar, ...style }}>
      <Toolbar style={{ justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <img
            style={{
              height: "40px",
              margin: "2rem",
            }}
            src={neopharm}
            alt="neopharmLogo"
          />
          <Typography sx={{ marginLeft: "5rem" }} variant="h5">
            {stateroles.name ? getCurrentTimeMessage() : null}
          </Typography>
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <FormControl
            sx={{
              marginTop: "0.5rem",
              marginRight: "2rem",
              minWidth: 200,
              backgroundColor: "#ffffff",
              color: "#000000",
              borderRadius: "5px",
            }}
            size="small"
          >
            {stateroles.userId && stateroles.customers.length > 1 ? (
              <Tooltip title={stateroles.userCustDes}>
                <Select
                  id="custNum-standard"
                  value={custNum ? custNum : stateroles.userId}
                  onChange={handleChange}
                >
                  {stateroles.customers &&
                    stateroles.customers.map((component, index) => (
                      <MenuItem key={index} value={component.CUSTNAME}>
                        {component.CUSTDES}
                      </MenuItem>
                    ))}
                </Select>
              </Tooltip>
            ) : stateroles.userId && stateroles.customers.length <= 1 ? (
              <Tooltip title={stateroles.userCustDes}>
                <TextField
                  id="outlined-basic"
                  value={stateroles.userCustDes}
                  variant="outlined"
                  disabled
                  size="small"
                />
              </Tooltip>
            ) : null}
          </FormControl>
          {stateroles.name ? <LogOut /> : null}

          {stateroles.name && (
            <Tooltip title="יציאה" >
              <IconButton
                onClick={async () => {
                  try {
                    const response = await axios.get(`/log_out`);
                    if (response.status == 200) {
                      dispatchroles({
                        type: "USER",
                        payload: {
                          value: {
                            customers: [],
                            roles: [],
                          },
                        },
                      });
                      dispatch({
                        type: "DATA_RESPONSE",
                        payload: { value: [] },
                      });
                      navigate("/");
                    }
                  } catch (error) {
                    if (error.response?.status == 403) {
                      navigate("/");
                    }
                  }
                }}
                sx={{
                  margin: "1rem",
                  backgroundColor: "#d32f2f",
                  color: "#fff",
                  width: 45,
                  height: 45,
                  "&:hover": {
                    backgroundColor: "#b71c1c",
                  },
                }}
              >
                <LogoutIcon />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default CustomToolbar;
